module.exports = __webpack_public_path__ + "static/headshot-2f95aec8a3983eb3276fca56ff458175.jpg";